import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

/**
 * CarPortal component - displays car portal content
 */
const CarPortal = ({ sitecoreContext }) => {
  return (
    <div className="car-portal">
      <div className="container">
        <h2>Car Portal</h2>
        <p>This is the car portal component.</p>
        <div className="portal-content">
          <div className="alert alert-info">Car portal functionality will be implemented here.</div>
        </div>
      </div>
    </div>
  );
};

export default withSitecoreContext()(CarPortal);
